const HANDLE_MODAL_VISIBLE = 'scratch-gui/disguised-block/HANDLE_MODAL_VISIBLE';
const SELECT_DISGUISED_BLOCK = 'scratch-gui/disguised-block/SELECT_DISGUISED_BLOCK';


const initialState = {
    modalVisible: false,
    selectedDisguisedBlock: null,

};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
        case HANDLE_MODAL_VISIBLE:
            return Object.assign({}, state, {
                modalVisible: action.modalVisible
            });
            break;
        case SELECT_DISGUISED_BLOCK:
            return Object.assign({}, state, {
                selectedDisguisedBlock: action.selectedDisguisedBlock
            });
            break;
        default:
            return state;
    }
};

const handleModalVisible = (modalVisible) => ({
    type: HANDLE_MODAL_VISIBLE,
    modalVisible,
});

const selectDisguisedBlock = (selectedDisguisedBlock) => ({
    type: SELECT_DISGUISED_BLOCK,
    selectedDisguisedBlock,
})

export {
    reducer as default,
    initialState as disguisedBlockInitialState,
    handleModalVisible,
    selectDisguisedBlock,
};
